import api from "./index";

export const getAllAssociateCompanyService = async (params) =>
  await api.get("/provider-association", { params });

export const getUserDocumentService = async (document, params) =>
  await api.get(`/provider-association/service-provider/${document}`, {
    params,
  });

export const createAssociateCompanyService = async (data) =>
  await api.post("/provider-association", data);

export const removeAssociationCompanyService = async (serviceProviderId, params) =>
  await api.delete(`/provider-association/providers/${serviceProviderId}`, {
    params,
  });

export const updateLoginPermissionService = async (serviceProviderId, data, params) =>
  await api.put(
    `/provider-association/providers/${serviceProviderId}/update-manage-permission`,
    data,
    { params },
  );

export const updateAssociateCompanyService = async (serviceProviderId, data, params) =>
  await api.put(`/provider-association/providers/${serviceProviderId}`, data, {
    params,
  });
